export default __webpack_public_path__ + "static/media/JOSA SYLLABUS_2026-27 CLASS 6.5f918563.pdf";